import React from 'react';
import { useTheme } from '@mui/material';
import { CalendarMonthOutlined } from '@mui/icons-material';
import { OrderPageOutlinedTextField } from './OrderPageOutlinedTextField';

type OrderPageDateFieldProps = {
  id: string;
  label: string;
  value: string;
  onOpen: () => void;
  error?: boolean;
  helperText?: React.ReactNode;
};

export const OrderPageDateField = ({ id, label, value, onOpen, error, helperText }: OrderPageDateFieldProps) => {
  const theme = useTheme();

  return (
    <OrderPageOutlinedTextField
      id={id}
      name={id}
      label={label}
      value={value}
      error={error}
      helperText={helperText}
      onClick={onOpen}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          onOpen();
        }
      }}
      InputProps={{
        readOnly: true,
        endAdornment: <CalendarMonthOutlined sx={{ fontSize: 20, color: theme.customTheme.palette.lineColor }} />,
      }}
      // InputProps styles the root, inputProps the native input
      // eslint-disable-next-line react/jsx-no-duplicate-props
      inputProps={{ dir: 'ltr', style: { cursor: 'pointer' } }}
    />
  );
};
